import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
      <div className="flex items-center justify-between mb-6">
        <h3
          className="text-xl md:text-2xl font-bold text-foreground-950"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          分类浏览
        </h3>
        <Link
          to="/category/romance"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          全部分类 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 flex flex-col items-center gap-3"
          >
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
              <i className={`${cat.icon} text-xl text-primary-600`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500">{cat.count}部</span>
          </Link>
        ))}
      </div>
    </section>
  );
}